// src/pages/ForgotPage.tsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { authApi } from "../lib/auth-api";
import { AuthLayout, Field } from "./LoginPage";

export function ForgotPage() {
  const [email, setEmail] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const r = await authApi.forgot({ email });
      setDone(r.message);
    } catch (err) {
      setError((err as Error).message);
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <AuthLayout title="パスワードリセット">
        <p className="text-sm text-slate-700 leading-relaxed">{done}</p>
        <div className="mt-5 text-center text-sm">
          <Link to="/login" className="text-blue-700 hover:underline">ログイン画面に戻る</Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="パスワードを忘れた">
      <form onSubmit={onSubmit} className="space-y-3">
        <p className="text-sm text-slate-600">
          登録したメールアドレスを入力してください。 リセットリンクをお送りします。
        </p>
        <Field label="メールアドレス">
          <input
            type="email" required value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="auth-input"
          />
        </Field>
        {error && <div className="auth-error">{error}</div>}
        <button type="submit" disabled={busy} className="auth-button">
          {busy ? "送信中…" : "リセットリンクを送信"}
        </button>
      </form>
      <div className="mt-4 text-center text-sm">
        <Link to="/login" className="text-blue-700 hover:underline">ログイン画面に戻る</Link>
      </div>
    </AuthLayout>
  );
}
